/**
 * Объект с возможными ответами статус кода от API
 */
export enum EApiStatus {
    OK = 0
}